import React from 'react';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
interface DeleteConfirmationProps {
  componentName: string;
  onConfirm: () => void;
  onCancel: () => void;
}
export function DeleteConfirmation({
  componentName,
  onConfirm,
  onCancel
}: DeleteConfirmationProps) {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-287">
      <div className="bg-white rounded-xl p-6 w-full max-w-md" data-id="element-288">
        <div className="flex items-center mb-4 text-red-600" data-id="element-289">
          <AlertTriangleIcon size={24} className="mr-3" data-id="element-290" />
          <h3 className="text-lg font-bold" data-id="element-291">Komponente löschen</h3>
        </div>
        <p className="mb-6 text-gray-700" data-id="element-292">
          Sind Sie sicher, dass Sie die Komponente{' '}
          <strong data-id="element-293">{componentName}</strong> löschen möchten? Diese Aktion kann
          nicht rückgängig gemacht werden.
        </p>
        <div className="flex justify-end gap-2" data-id="element-294">
          <button onClick={onCancel} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50" data-id="element-295">
            Abbrechen
          </button>
          <button onClick={onConfirm} className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg" data-id="element-296">
            Löschen
          </button>
        </div>
      </div>
    </div>;
}